export const updateSimpleRiskUsingHandler = async (
  updateRiskHandler, simpleRiskRating, riskProfile, isWealthManager, crudActions, saygScenariosEnabled) => {
  const newRiskProfile = { ...riskProfile,
    ...{
      selected: 'simple',
      rating: simpleRiskRating,
      completed_by_wealth_manager: Boolean(isWealthManager)
    } }

  if (saygScenariosEnabled) {
    await crudActions.update(newRiskProfile)
  } else {
    await updateRiskHandler(newRiskProfile)
  }
}

export const updateDetailedRiskUsingHandler = async (
  updateRiskHandler, riskProfile, formattedAssessmentResults, isWealthManager, crudActions, saygScenariosEnabled
) => {
  const newRiskProfile = { ...riskProfile,
    ...{
      selected: 'detailed',
      assessment: formattedAssessmentResults.risk.assessment,
      completed_by_wealth_manager: Boolean(isWealthManager)
    } }

  if (saygScenariosEnabled) {
    await crudActions.update(newRiskProfile)
  } else {
    updateRiskHandler(newRiskProfile)
  }
}

export const riskMappingValues = [
  '',
  'Conservative',
  'Moderate conservative',
  'Moderate',
  'Moderate aggressive',
  'Aggressive'
]

export const riskProfileDescriptions = {
  'Conservative': 'Conservative portfolios are typically mostly invested into cash and bonds with little to no exposure to equity. Think money market account at your bank. They aim for a low return rate that is close to or slightly above inflation. Conservative portfolios are mostly used for short-term savings goals, anywhere below 1 year.',

  'Moderate conservative': 'Functioning as a blend of conservative and moderate. Effective for short to medium-term goals anywhere between 1 to 3 years, these portfolios usually have less market fluctuation due to lower equity exposure.',

  'Moderate': 'Aimed at a moderate return rate it also has moderate market fluctuations. These types of portfolios are typically for medium-term investment goals anywhere between 3 to 5 years',

  'Moderate aggressive': 'These portfolios have slightly reduced exposure to risky assets and are typically used for medium to long-term investment goals. Moderate aggressive portfolios are for medium to long term goals, between 5 to 7 years. For retirement products, this is the maximum risk profile one can take due to regulation 28.',

  'Aggressive': 'Typically, these portfolios are aimed at higher growth through exposure to risky assets such as equities and property that by their nature have a higher risk associated with them. Aggressive portfolios are for long term goals, more than 7 years.'
}
